// src/index.js
import React from 'react';
import ReactDOM from 'react-dom';
import './utilities/axios-setup'; // Global Axios Interceptor for App Check
import App from './App';
import './index.css';

import GlobalErrorBoundary from './components/GlobalErrorBoundary';

import reportWebVitals from './reportWebVitals';
import logger from './services/logger';

ReactDOM.render(
  <React.StrictMode>
    <GlobalErrorBoundary>
      <App />
    </GlobalErrorBoundary>
  </React.StrictMode>,
  document.getElementById('root')
);

// Report Web Vitals to our unified logger
reportWebVitals((metric) => {
  logger.performance('web-vitals', Math.round(metric.value), {
    metric_name: metric.name,
    metric_id: metric.id,
    metric_delta: metric.delta,
    metric_rating: metric.rating // good/needs-improvement/poor
  });
});
